export enum MenuSectionTag {
  RECOMMENDED = 'Рекомендуем',
  SEASON = 'Сезонное меню',
  SALADS = 'Салаты и закуски',
  DRINKS = 'Напитки',
  DESERTS = 'Десерты'
}